export default __webpack_public_path__ + "static/media/statement.4826aef5.png";